import { render, staticRenderFns } from "./EquipmentMaintenanceTab.vue?vue&type=template&id=8212d564&scoped=true&"
import script from "./EquipmentMaintenanceTab.vue?vue&type=script&lang=ts&"
export * from "./EquipmentMaintenanceTab.vue?vue&type=script&lang=ts&"
import style0 from "./EquipmentMaintenanceTab.vue?vue&type=style&index=0&id=8212d564&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8212d564",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VDataTable,VTextField})
